import { m } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';

// components
import Page from '../components/Page';
import { MotionContainer, varBounce } from '../components/animate';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
  backgroundImage: 'url("/assets/royal-blue-background.png")', 
  backgroundSize: 'cover', 
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
  color: '#ffffff', 
}));

// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <Page title="404 Page Not Found" sx={{ height: 1 }}>
      <RootStyle>
        <Container component={MotionContainer}>
          <Box sx={{ maxWidth: 680, margin: 'auto', textAlign: 'center' }}>
            <m.div variants={varBounce().in}>
              <Typography mt={0} variant="h3" paragraph>Oops, that page no longer exists</Typography>
            </m.div>
            <Typography component="div" mb={7}>
              We've recently updated our dashboard, so you may have followed an old URL. Please update your bookmarks, or 
              go to the Dashboard Home screen and manually navigate to the section you were looking for.
            </Typography>

            <Button to="/" size="large" color="primaryGreen" variant="contained" component={RouterLink} sx={{ textDecoration: 'none' }}>
              Go to Dashboard Home
            </Button>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
